export enum sizeOptions {
  md = "md",
  lg = "lg",
  xl = "xl",
}
